module.exports = __webpack_public_path__ + "static/media/S.270e3060.jpg";